import { InstFullNameInput } from "../components/InstFullNameInput";
import { InstIdTypeField } from "../components/InstIdTypeField";
import { InstIdField } from "../components/InstIdField";
import { InstEmailInput } from "../components/InstEmailInputs";
import { InstDepartmentField } from "../components/InstDepartmentField";

/**
 * Agrupa los componentes que conforman los campos del formulario
 * de acceso institucional tipo FormEmail.
 *
 * Este objeto facilita la importación y el acceso centralizado a los
 * distintos campos del formulario desde el componente principal,
 * permitiendo referenciarlos mediante `EmailFormFields`.
 *
 * @constant
 * @type {Object}
 * @property {React.ComponentType} InstFullNameInput - Campo para ingresar el nombre y apellido.
 * @property {React.ComponentType} InstIdTypeField - Campo para seleccionar el tipo de documento.
 * @property {React.ComponentType} InstIdField - Campo para ingresar el número de documento.
 * @property {React.ComponentType} InstEmailInput - Campo para ingresar el correo electrónico.
 * @property {React.ComponentType} InstDepartmentField - Campo para seleccionar el departamento.
 */
export const EmailFormFields = {
    InstFullNameInput,
    InstIdTypeField,
    InstIdField,
    InstEmailInput,
    InstDepartmentField
}